/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Has_BasinInputs */

const cs_form_has_basin = /** @type {(inputs: Form_Has_BasinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bazén`)
};

const en_form_has_basin = /** @type {(inputs: Form_Has_BasinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pool`)
};

/**
* | output |
* | --- |
* | "Pool" |
*
* @param {Form_Has_BasinInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_has_basin = /** @type {((inputs?: Form_Has_BasinInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Has_BasinInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_has_basin(inputs)
	return cs_form_has_basin(inputs)
});